import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e7dccdec")
const _hoisted_1 = {
  class: "onboarding-modal",
  ref: "modalContainerRef"
}
const _hoisted_2 = {
  ref: "modalBodyRef",
  class: "onboarding-modal-body"
}
const _hoisted_3 = { id: "close-modal" }
const _hoisted_4 = { id: "info-wrap" }
const _hoisted_5 = {
  key: 0,
  id: "step-count"
}
const _hoisted_6 = {
  key: 1,
  id: "step-count"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"visibility":"hidden"} }, "0", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { id: "title" }
const _hoisted_10 = { id: "info" }
const _hoisted_11 = {
  key: 2,
  class: "btns"
}
const _hoisted_12 = {
  key: 3,
  class: "btns"
}
const _hoisted_13 = {
  id: "pointer",
  ref: "pointerRef"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeOnboarding && _ctx.closeOnboarding(...args))),
            style: {"width":"15px","height":"15px","margin-right":"1rem"}
          }, [
            _createVNode(_component_CloseSVG, {
              propId: 'onboarding-modal-close',
              fillColor: '#0096ff',
              strokeColor: '#fff',
              flipFill: '#fff',
              flipStroke: '#0096ff'
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.index && _ctx.totalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.index) + " / " + _toDisplayString(_ctx.totalSteps), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.info), 1),
          (_ctx.index === _ctx.totalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  id: "finish-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeOnboarding && _ctx.closeOnboarding(...args)))
                }, " Finish Tour ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeOnboarding && _ctx.closeOnboarding(...args))),
                  id: "left-btn"
                }, "Skip Tour"),
                _createElementVNode("button", {
                  id: "right-btn",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.incrementStep && _ctx.incrementStep(...args)))
                }, "Next")
              ]))
        ]),
        _createElementVNode("div", _hoisted_13, null, 512)
      ], 512)
    ], 512)
  ]))
}